// ./src/components/features/EventShare/eventShareRules.ts
//
// ROADMAP #138 — the share surfaces' PURE rules (no React, no CSS), so `check-event-share` can RUN them.

import { CREW_CAPABILITY } from '@/config/crewCapabilities';

/** The QR is made at print resolution and scaled down on screen, so a download is sharp on a poster. */
export const QR_RESOLUTION = 1024;

/** One-tap QR colours (any colour can still be picked). */
export const QR_SWATCHES = ['#1a1a1a', '#1971c2', '#6741d9', '#e8590c', '#2f9e44', '#c2255c'];

/** The colour a QR starts in. */
export const QR_DEFAULT_COLOR = '#1a1a1a';

const fileSafe = (value?: string | null): string =>
  String(value ?? '')
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, '-')
    .replace(/^[-_]+|[-_]+$/g, '');

/**
 * The downloaded QR's file name: "<stem>[-<channel code>]-qr.png" (e.g. "summer-gala-fb-qr.png"). A stem or code with
 * nothing file-safe left in it is dropped rather than leaving "--qr.png"; with no stem at all it is "event".
 */
export const qrFileName = (stem?: string | null, code?: string | null): string => {
  const base = fileSafe(stem) || 'event';
  const tag = fileSafe(code);

  return `${base}${tag ? `-${tag}` : ''}-qr.png`;
};

/**
 * May this person TAG a share link with one of the event's marketing channels?
 *
 * The event's owner, or crew holding `event.operate` — the rule the server applies to listing the event account's
 * channels (`MarketingChannelCore.resolveAccountViaEvent`), which is the AUTHORITY: for anyone else it lists none. This
 * copy only spares a read that would come back empty, and keeps the picker away from crew who cannot use it.
 * ⓘ Not while the crew access is being read. It can still say yes for a moment before that read starts (the access
 *   context begins not-loading), or after it FAILED — the server answers those with no channels, never someone else's.
 */
export const mayTagWithChannels = (crew: {
  loading: boolean;
  isCrewMode: boolean;
  hasCapability: (capability: string) => boolean;
}): boolean => !crew.loading && (!crew.isCrewMode || crew.hasCapability(CREW_CAPABILITY.EVENT_OPERATE));
